import script from "./publisherTable.vue?vue&type=script&setup=true&lang=js"
export * from "./publisherTable.vue?vue&type=script&setup=true&lang=js"

import "./publisherTable.vue?vue&type=style&index=0&id=ed259a90&lang=css"
import "./publisherTable.vue?vue&type=style&index=1&id=ed259a90&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed259a90"]])

export default __exports__